import styled from 'styled-components';

export const GoTribeTag = styled.section(
    props =>`
    background: #fffbf1;
    padding: 0.8rem 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.8rem;
`
)

export const IconWrap = styled.span`
    padding-right: 2rem;
    img{
        width: 100%;
        height: 100%;
    }
`

export const Text = styled.p(
  props => `
    font-size: 1.6rem;
    color: #1f232e;
    line-height: 2.5rem;
    
`,
);

